/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Issoftphoneenabled2Inputs */

const en_entity_issoftphoneenabled2 = /** @type {(inputs: Entity_Issoftphoneenabled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Softphone Enabled`)
};

const de_entity_issoftphoneenabled2 = /** @type {(inputs: Entity_Issoftphoneenabled2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Softphone aktiviert`)
};

/**
* | output |
* | --- |
* | "Is Softphone Enabled" |
*
* @param {Entity_Issoftphoneenabled2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_issoftphoneenabled2 = /** @type {((inputs?: Entity_Issoftphoneenabled2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Issoftphoneenabled2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_issoftphoneenabled2(inputs)
	return de_entity_issoftphoneenabled2(inputs)
});
export { entity_issoftphoneenabled2 as "entity_isSoftphoneEnabled" }